import type { AnyRouter } from "@tanstack/react-router"
import { useNavigate, useSearch } from "@tanstack/react-router"
import { useForm } from "react-hook-form"
import {
  WAREHOUSE_SHELVING_LAYOUT_ROUTE_PATH,
  WAREHOUSE_SHELVING_ROUTE_PATH,
} from "routes/app/admin/warehouses/$warehouseId/_layout.shelving"

import { WAREHOUSE_SHELVING_FILTERS_DEFAULT } from "../constants"

import type { WarehouseShelvingBinSize, WarehouseShelvingListFilter } from "@/graphql/codegen/graphql"

interface UseWarehouseShelvingSearchNavigateReturn {
  formMethods: ReturnType<typeof useForm<WarehouseShelvingListFilter>>
  currentNavigate: ReturnType<typeof useNavigate>
  currentSearch: ReturnType<typeof useSearch<AnyRouter, undefined, true>>
}

export const useWarehouseShelvingSearchNavigate = (): UseWarehouseShelvingSearchNavigateReturn => {
  const currentNavigate = useNavigate({ from: WAREHOUSE_SHELVING_ROUTE_PATH })
  const currentSearch = useSearch<AnyRouter, undefined, true>({
    from: WAREHOUSE_SHELVING_LAYOUT_ROUTE_PATH,
    strict: true,
  })

  const formMethods = useForm<WarehouseShelvingListFilter>({
    defaultValues: WAREHOUSE_SHELVING_FILTERS_DEFAULT,
    values: {
      coldStorage: currentSearch.coldStorage,
      h3ColdStorage: currentSearch.h3ColdStorage,
      deep: currentSearch.deep,
      binSize: currentSearch.binSize as WarehouseShelvingBinSize[] | [],
      isDoNotUse: currentSearch.isDoNotUse,
      isAvailable: currentSearch.isAvailable,
      isUndefined: currentSearch.isUndefined,
    },
  })

  return {
    currentNavigate,
    currentSearch,
    formMethods,
  }
}
